import React, { useState, useEffect } from 'react';
import { number, func, bool } from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import {TIPS} from "../../../consts/tips";

import { useFormErrors } from '../../hooks/useFormErrors';
import { FormError, FormLabel, InputCodigo, Modal } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const OrganoJudicialModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        codigoOrganoJudicial: '',
        departamentoJudicial: '',
        fuero: '',
        secretaria: ''
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
        showInfo: false
    });

    const mount = () => {

        if (props.id > 0) {
            FindOrganoJudicial();
        }
   
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const [ formValues, formHandle, , formSet ] = useForm({
        codigoOrganoJudicial: '',
        departamentoJudicial: '',
        fuero: '',
        secretaria: ''
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0) {
                AddOrganoJudicial();
            }
            else {
                ModifyOrganoJudicial();
            }
        };
    };
    const handleClickCancelar = () => {
        props.onDismiss();
    }
    
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  

    // funciones
    function getErrors() {

        const errors = {};

        if (formValues.codigoOrganoJudicial.length === 0) errors.codigoOrganoJudicial = VALIDATION_MESSAGE.REQUIRED
        if (formValues.departamentoJudicial.length === 0) errors.departamentoJudicial = VALIDATION_MESSAGE.REQUIRED
        if (formValues.fuero.length === 0) errors.fuero = VALIDATION_MESSAGE.REQUIRED
        if (formValues.secretaria.length === 0) errors.secretaria = VALIDATION_MESSAGE.REQUIRED

        return errors;
    }   
    
    function FindOrganoJudicial() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {               
                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });
                formSet({
                    codigoOrganoJudicial: data.codigoOrganoJudicial,
                    departamentoJudicial: data.departamentoJudicial,
                    fuero: data.fuero,
                    secretaria: data.secretaria
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.ORGANO_JUDICIAL,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddOrganoJudicial() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveOrganoJudicial(method, paramsUrl);
    }
    
    function ModifyOrganoJudicial() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveOrganoJudicial(method, paramsUrl);
    }    

    function SaveOrganoJudicial(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
                ...state.entity,
                codigoOrganoJudicial: formValues.codigoOrganoJudicial,
                departamentoJudicial: formValues.departamentoJudicial,
                fuero: formValues.fuero,
                secretaria: formValues.secretaria
        };
    
        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.ORGANO_JUDICIAL,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

  return (
    <>

    <Modal
      size="lg"
      title={`Órgano judicial: ${(props && props.id > 0) ? state.entity.codigoOrganoJudicial : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
      onEscape={handleClickCancelar}
      body={(
            <div className="row">

                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="codigoOrganoJudicial" required>Órgano judicial</FormLabel>
                    <InputCodigo
                        name="codigoOrganoJudicial"
                        placeholder=""
                        className={`form-control ${errorOf('codigoOrganoJudicial') ? 'is-invalid' : ''}`}
                        value={ formValues.codigoOrganoJudicial }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        maxLength={20}
                    />
                    <FormError message={errorOf('codigoOrganoJudicial')} />
                </div>
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="departamentoJudicial" required>Departamento judicial</FormLabel>
                    <input
                        name="departamentoJudicial"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('departamentoJudicial') ? 'is-invalid' : ''}`}
                        value={ formValues.departamentoJudicial }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('departamentoJudicial')} />
                </div>
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="fuero" required>Fuero</FormLabel>
                    <input
                        name="fuero"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('fuero') ? 'is-invalid' : ''}`}
                        value={ formValues.fuero }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('fuero')} />
                </div>
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="secretaria" required>Secretaría</FormLabel>
                    <input
                        name="secretaria"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('secretaria') ? 'is-invalid' : ''}`}
                        value={ formValues.secretaria }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('secretaria')} />
                </div>

            </div>
      )}
      footer={!props.disabled ? (<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

OrganoJudicialModal.propTypes = {
    disabled: bool,
    id: number.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

OrganoJudicialModal.defaultProps = {
    disabled: false
};

export default OrganoJudicialModal;